﻿import { NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { NguiAutoCompleteModule } from "@ngui/auto-complete";


import {ValidationFormComponent} from '../validation/validationForm.component';

import {TextBoxComponent} from './textBox/textBox.component'
import {HorizontalTextBoxComponent} from './horizontaltextBox/horizontaltextBox.component';
import {EditlistComponent} from './editlist/editlist.component';
import {ComboBoxComponent} from './comboBox/comboBox.component';
import {PasswordStrengthBarComponent} from "./passwordstrength/passwordStrengthBar.component";
import {ValidationPanelComponent} from "./validationPanel/validationPanel.component";
import {CaptchaComponent} from "./captcha/captcha.component";
import {Modal} from "./dialog/dialog.component";
import { ModalService } from "./dialog/dialog.service";
import { ModalWindow } from "./modal/modal";
import { Open } from "./modal/open.component";
import { Alert } from "./modal/alert";
import { TriStateCheckboxComponent} from  "./tristatecheckbox/tristate-checkbox.component";

@NgModule({
    imports: [BrowserModule, FormsModule, NguiAutoCompleteModule],
    declarations: [ValidationFormComponent, ValidationPanelComponent, TextBoxComponent,  HorizontalTextBoxComponent,
        CaptchaComponent, EditlistComponent, ComboBoxComponent, PasswordStrengthBarComponent, Modal, ModalWindow, Open, Alert, TriStateCheckboxComponent],
    exports: [ValidationFormComponent, ValidationPanelComponent, TextBoxComponent, HorizontalTextBoxComponent,
        CaptchaComponent, EditlistComponent, ComboBoxComponent, PasswordStrengthBarComponent, Modal, ModalWindow, Open, Alert, TriStateCheckboxComponent],
     providers: [ModalService]
})
export class SharedModule
{
}